<template>
    <div class="container paymentList_wrap">

        <p class="page_title">결제내역</p>

        <section class="section sec1">
            <div class="sec_titbox">
                <div class="leftbox">
                    <div class="input_box date">
                        <VueDatePicker range :model-value="rangeDate" @update:model-value="searchFilter" :enable-time-picker="false"
                            :clearable="false" :teleport="true" />
                    </div>
                    <button type="button" class="btn ver2 reset_btn" @click="resetSearch">
                        <span class="icon"></span>
                        <span class="txt">초기화</span>
                    </button>
                </div>
                <div class="rightbox">
                    <div class="input_box big sch_total">
                        <label for="schTotal" class="label_text">검색합계</label>
                        <input type="text" class="input_text" id="schTotal" :value="allPrice" readonly>
                    </div>
                </div>
            </div>
            <div class="tbl_wrap">
                <DataTable ref="table" :data="paymentList" class="tbl" :columns="columns" :options="dtOptions">
                </DataTable>
            </div>
        </section>
        <PaymentDetailModal v-if="paymentDetailModal" @paymentDetailModalClose="paymentDetailModalClose"
            :paymentDetail="paymentDetail" />
    </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import { onMounted, ref, computed, getCurrentInstance } from 'vue';
import { getPaymentList } from '@/api';
import PaymentDetailModal from '@/components/PaymentDetailModal.vue';
DataTable.use(DataTablesCore);
const { proxy } = getCurrentInstance();
const rangeDate = ref([])
const paymentList = ref([]);
const paymentDetailModal = ref(false);
const paymentDetailModalClose = () => {
    paymentDetailModal.value = false;
}

const paymentDetail = ref({});

const dtOptions = {
    paging: true,  // 페이지네이션 활성화
    searching: false,  // 검색 활성화
    info: false,
    pageLength: 10,
    lengthChange: false,
    language: {
        emptyTable: '데이터가 없습니다.', // 메시지 변경
    },
}

const resetSearch = () => {
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    searchFilter([startDate, endDate])
}


const searchFilter = async (modelData) => {
    rangeDate.value = modelData
    const [start, end] = modelData;
    const startDate = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')}`;
    const endDate = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')}`;
    const res = await getPaymentList(startDate, endDate);
    paymentList.value = [...res.data.list];
}


const allPrice = computed(() => {
    return paymentList.value.reduce((acc, curr) => acc + curr.pricing, 0);
})

onMounted(async () => {
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    const endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
    rangeDate.value = [startDate, endDate]
    const res = await getPaymentList(`${startDate.getFullYear()}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getDate().toString().padStart(2, '0')}`, `${endDate.getFullYear()}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`);
    console.log(res.data.list);
    paymentList.value = [...res.data.list];
})


const columns = [
    { data: 'pay_date', title: '결제일' },
    { data: 'email', title: '계정' },
    {
        data: 'type', title: 'Plan', render: (data) => {
            if (data == 0) {
                return `<img src="${proxy.$STATIC_URL}/admin/img/plan_b.png" alt="" class="plan_icon">`;
            } else if (data == 1) {
                return `<img src="${proxy.$STATIC_URL}/admin/img/plan_p.png" alt="" class="plan_icon">`;
            }
        }
    },
    {
        data: 'pricing', title: '금액', render: (data) => {
            return `<span class="bold">${data.toLocaleString()}</span>`
        }
    },
    {
        data: 'pay_method', title: '결제방법', render: (data) => {
            if (data == 1) {
                return `<span class="badge_icon">
            <img src="${proxy.$STATIC_URL}/admin/img/badge_googleplay.png" alt="" class="icon">
            <span class="txt">구글플레이</span>
        </span>`
            } else {
                return `<span class="badge_icon">
            <img src="${proxy.$STATIC_URL}/admin/img/badge_appstore.png" alt="" class="icon">
            <span class="txt">앱스토어</span>
        </span>`
            }
        }
    },
    {
        data: 'status', title: '정상유무', render: (data) => {
            if (data == 1) {
                return `<span class="badge big complete">결제완료</span>`
            } else {
                return `<span class="badge big cancel">결제취소</span>`
            }
        }
    },
    {
        data: null, title: '상세보기', render: () => {
            return `<span class="badge_icon view_btn">
                                        <img src="${proxy.$STATIC_URL}/admin/img/badge_search.png" alt="" class="icon">
                                        <span class="txt">보기</span>
                                    </span>`
        },
        createdCell: (td, cellData, rowData) => {
            td.querySelector('.view_btn').addEventListener('click', (event) => {
                event.preventDefault();
                paymentDetail.value = rowData;
                paymentDetailModal.value = true;
            });
        }
    },
];
</script>
<style scoped>
:deep(.dt-paging-button) {
    width: 40px;
    height: 40px;
    font-size: 14px;
    line-height: 157%;
    letter-spacing: -0.04em;
    color: var(--color-text);
    border: 1px solid var(--color-border2);
    border-radius: 8px;
    background: var(--color-white);
    overflow: hidden;
    margin: 0 10px;
}

:deep(.dt-paging-button.current) {
    font-weight: 700;
    color: var(--color-white);
    background: var(--color-gradient1);
}

:deep(.dt-paging nav) {
    display: flex;
    justify-content: center;
}

:deep(.dt-paging) {
    margin-top: 20px;
    margin-bottom: 20px;
}

:deep(.dt-search) {
    display: none
}
</style>
